'use strict';

function getValueList(itemList) {
  var itemValues = [];
  var item;

  for (item in itemList) {
    if (itemList.hasOwnProperty(item)) {
      itemValues.push(itemList[item]);
    }
  }

  return itemValues;
}

module.exports = {
  getValueList: getValueList
};
